const company = JSON.parse(localStorage.getItem('company')) || {};

export const state = company
  ? { status: { added: true }, company }
  : { status: { added: false }, company: null }

export const getters = {
  getCompany: state => {
    return {
      ...state.company,
    }
  }
}

export const actions = {
  // Adds a company.
  // eslint-disable-next-line no-unused-vars
  addCompany({ dispatch, commit }, company) {
    try {

      commit('addCompanyRequest', company);
      commit('addCompanySuccess', company);      
      localStorage.setItem('company', JSON.stringify(company))

    } catch (error) {
      console.log(error)
      commit('addCompanyFailure', error);
      dispatch('notification/error', error.message, { root: true })
    }

  },

  // Remove a company from the state
  removeCompany({ commit }) {
    commit('removeCompany');
    localStorage.removeItem('company');
  },

};

export const mutations = {
  addCompanyRequest(state, company) {
    state.status = { added: true };
    state.company = company;
  },
  addCompanySuccess(state, company) {
    state.status = { added: true };
    state.company = company;
  },
  addCompanyFailure(state) {
    state.status = { added: false };
    state.company = null;
  },
  removeCompany(state) {
    state.status = { added: false};
    state.company = null;
  },
};

